import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import HTMLRenderer from 'react-html-renderer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Modal from 'components/Luxkit/Modal/Modal'
import Accordion from 'components/Luxkit/Accordion'

const FacilitiesText = styled(BodyText)`
  padding-top: ${rem(12)};

  &.list {
    padding-top: ${rem(4)};
  }
`

interface Props {
  shipFacilities: Array<{
    title: string;
    description: string;
  }>;
}

function ShipFacilitiesModal({ shipFacilities }: Props) {
  return <Modal title="Facilities">
    {shipFacilities.map(facility => (
      <Accordion size="small" heading={facility.title} key={facility.title}>
        <HTMLRenderer
          html={facility.description}
          components={{
            h4: ({ children }) => <Heading variant="heading4">{children}</Heading>,
            b: ({ children }) => <FacilitiesText variant="large" weight="bold">{children}</FacilitiesText>,
            p: ({ children }) => <BodyText variant="medium">{children}</BodyText>,
            ul: ({ children }) => <BodyText variant="small">{children}</BodyText>,
            li: ({ children }) => <FacilitiesText variant="medium" className="list">{children}</FacilitiesText>,
          }}/>
      </Accordion>
    ))}
  </Modal>
}

export default ShipFacilitiesModal
